import commonZhHK from './common_zh-HK'

const membershipZhHK = {
  membership: {
    ...commonZhHK,
  }
}

export default membershipZhHK